import { render, staticRenderFns } from "./secondaryList.vue?vue&type=template&id=ce77f1ba&"
import script from "./secondaryList.vue?vue&type=script&lang=js&"
export * from "./secondaryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce77f1ba')) {
      api.createRecord('ce77f1ba', component.options)
    } else {
      api.reload('ce77f1ba', component.options)
    }
    module.hot.accept("./secondaryList.vue?vue&type=template&id=ce77f1ba&", function () {
      api.rerender('ce77f1ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/organisms/SecondaryList/secondaryList.vue"
export default component.exports